import type { SDKConfig } from './types';

/**
 * 入口特性开关。关闭时仅在公开入口不透传对应参数，底层实现代码保留，便于后续重新开放。
 */
export const ENTRY_FEATURES = {
  cache: false,
  customTranslate: false,
} as const;

type EntryConfig = SDKConfig & { cacheManager?: unknown };

/**
 * 裁剪 SDK 入口配置：关闭的能力静默丢弃，不抛错、不透传。
 */
export function gateEntryConfig(config: EntryConfig): SDKConfig {
  const {
    cache: _cache,
    translate: _translate,
    cacheManager: _cacheManager,
    ...rest
  } = config;

  const gated: SDKConfig = {
    ...rest,
    ...(ENTRY_FEATURES.cache ? { cache: config.cache } : { cache: false }),
    ...(ENTRY_FEATURES.customTranslate ? { translate: config.translate } : {}),
  };

  if (ENTRY_FEATURES.customTranslate) {
    const hasGetToken = !!gated.getToken;
    const hasTranslate = !!gated.translate;
    if (!hasGetToken && !hasTranslate) {
      throw new Error('必须提供 getToken 或 translate 函数');
    }
    if (hasGetToken && hasTranslate) {
      throw new Error('getToken 与 translate 函数互斥，只能选择一种鉴权方案');
    }
  } else if (!gated.getToken) {
    throw new Error('必须提供 getToken 函数');
  }

  return gated;
}

/** 是否允许从入口透传 / 使用 cache 相关能力 */
export function isCacheEntryEnabled(): boolean {
  return ENTRY_FEATURES.cache;
}
